import { __classPrivateFieldSet, __classPrivateFieldGet } from '../../external_node_modules/tslib/tslib.es6.js';

var _CategoryEntity_category, _CategoryEntity_products;
class CategoryEntity {
    constructor(category) {
        _CategoryEntity_category.set(this, void 0);
        _CategoryEntity_products.set(this, []);
        __classPrivateFieldSet(this, _CategoryEntity_category, category, "f");
    }
    get showFilters() {
        var _a;
        return (_a = __classPrivateFieldGet(this, _CategoryEntity_category, "f").showFilters) !== null && _a !== void 0 ? _a : false;
    }
    get name() {
        return __classPrivateFieldGet(this, _CategoryEntity_category, "f").name;
    }
    get type() {
        return __classPrivateFieldGet(this, _CategoryEntity_category, "f").type;
    }
    get title() {
        return __classPrivateFieldGet(this, _CategoryEntity_category, "f").title;
    }
    get description() {
        return __classPrivateFieldGet(this, _CategoryEntity_category, "f").description;
    }
    get products() {
        return __classPrivateFieldGet(this, _CategoryEntity_products, "f");
    }
    get backgrounds() {
        return __classPrivateFieldGet(this, _CategoryEntity_category, "f").backgrounds;
    }
    addProduct(product) {
        __classPrivateFieldGet(this, _CategoryEntity_products, "f").push(product);
    }
}
_CategoryEntity_category = new WeakMap(), _CategoryEntity_products = new WeakMap();

export { CategoryEntity };
//# sourceMappingURL=category.entity.js.map
